import { render } from "./CategoriesBulkSelectionPanel.vue?vue&type=template&id=20c7df4a&scoped=true"
import script from "./CategoriesBulkSelectionPanel.vue?vue&type=script&lang=js"
export * from "./CategoriesBulkSelectionPanel.vue?vue&type=script&lang=js"

import "./CategoriesBulkSelectionPanel.vue?vue&type=style&index=0&id=20c7df4a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c7df4a"]])

export default __exports__